module.exports = __webpack_public_path__ + "media/images/section-bg-photo-f4ee64269db7ac72bcbba153db0aba52.jpg";